import { render, staticRenderFns } from "./ApproveProductsModal.vue?vue&type=template&id=745e6e13"
import script from "./ApproveProductsModal.vue?vue&type=script&lang=js"
export * from "./ApproveProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports